import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=4b641696&scoped=true&"
import script from "./Page404.vue?vue&type=script&lang=ts&"
export * from "./Page404.vue?vue&type=script&lang=ts&"
import style0 from "./Page404.vue?vue&type=style&index=0&id=4b641696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b641696",
  null
  
)

export default component.exports